module.exports = __webpack_public_path__ + "img/project-details.2b699805.jpg";